import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        filterButton: {
            color: 'text.default',
            background: 'background.light',
            borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            display: 'inline-flex',
            alignItems: 'center',
            h: 'auto',
            width: {base: remCalc(115), lg: 'auto'},
            iconSpacing: '0',
            flexDirection: {base: 'row-reverse', lg: 'row'},
        },
        filterText: {
            textStyle: 'body-medium',
            fontWeight: '400',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            flex: '1 0 0',
        },
        filterIcon: {
            boxSize: 'iconsSize.small',
            color: 'background.dark',
            width: {base: remCalc(24)},
            height: {base: remCalc(24)},
        },
        mobile: {
            display: {
                base: 'inline',
                lg: 'none',
            },
        },
        desktop: {
            display: {
                base: 'none',
                lg: 'inline',
            },
        },
        gridViewIcon: {
            boxSize: 'iconsSize.medium',
            color: 'background.dark',
            fill: 'background.light',
        },
        filtersButtonSpecific: {
            p: {base: ['xsmall.base'], lg: ['xsmall.lg']},
            paddingInline: {base: ['xsmall.lg'], lg: ['small.lg']},
            gap: {base: ['xsmall.lg'], lg: ['small.lg']},
        },
        filterOpenMenu: {
            p: 'small.lg',
            borderRadius: 'none',
        },
        sortByFilterMenuList: {
            display: 'flex',
            flexDir: 'column',
            gap: 'xxsmall.base',
            borderRadius: 'none',
        },
        sortByFilterMenuItem: {
            width: 'full',
            marginTop: 0,
            color: 'text.default',
            variant: 'menu-link',
            textStyle: 'body-small',
        },
        gridViewButtonSpecific: {
            display: 'flex',
            flexDirection: 'row',
            paddingTop: remCalc(8),
            paddingBottom: remCalc(8),
            paddingLeft: 'small.base',
            paddingRight: 'small.base',
            gap: 'small.base',
        },
        selectedRefinementsContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            maxWidth: '100%',
            whiteSpace: 'nowrap',
            gap: 'small.base',
        },
        selectedRefinementsButton: {
            color: 'text.default',
            background: 'background.light',
            borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            border: 'large',
            borderStyle: 'solid',
            borderColor: 'button.background.secondary-hover',
            display: 'inline-flex',
            alignItems: 'center',
            h: 'auto',
            w: 'auto',
            iconSpacing: '0',
            flexDirection: 'row',
            gap: remCalc(8),
            paddingY: remCalc(8),
            paddingX: remCalc(16),
            justifyContent: 'center',
            maxHeight: remCalc(40),
        },
        selectedRefinementsIconBox: {
            boxSize: 'iconsSize.medium',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        removeAllButtonContainer: {
            w: '100%',
            h: '100%',
            display: 'flex',
            paddingY: remCalc(8),
            gap: remCalc(10),
            alignSelf: 'stretch',
        },
        removeAllButton: {
            maxHeight: remCalc(40),
            padding: remCalc(16),
            paddingInline: ['small.lg'],
            gap: remCalc(10),
        },
        refinementsSelectorButton: {
            p: ['xsmall.lg'],
            gap: ['small.lg'],
        },
    },
    variants: {
        selectedFilterButton: {
            filterText: {
                textStyle: 'body-small',
                fontWeight: 400,
                lineHeight: 'normal',
            },
            selectedRefinementsContainer: {
                alignItems: 'center',
                h: remCalc(40),
            },
            selectedRefinementsButton: {
                height: '100%',
            },
            removeAllButtonContainer: {
                p: 0,
                h: remCalc(40),
            },
        },
    },
}
